/** Client fields required to emit FEV (persona natural v1). */

export type FeClienteFields = {
  nombre?: string | null;
  telefono?: string | null;
  email?: string | null;
  cedula?: string | null;
  numeroDocumento?: string | null;
  numero_documento?: string | null;
  tipoDocumento?: string | null;
  tipo_documento?: string | null;
};

export type FeMissingField = 'nombre' | 'documento' | 'email';

export function feDocumentoNumero(c: FeClienteFields | null | undefined): string {
  if (!c) return '';
  return String(c.cedula || c.numeroDocumento || c.numero_documento || '').replace(/\D/g, '');
}

export function feMissingClientFields(c: FeClienteFields | null | undefined): FeMissingField[] {
  const missing: FeMissingField[] = [];
  if (!c) {
    return ['nombre', 'documento', 'email'];
  }
  if (!String(c.nombre || '').trim()) missing.push('nombre');
  if (!feDocumentoNumero(c)) missing.push('documento');
  const email = String(c.email || '').trim();
  if (!email || !email.includes('@')) missing.push('email');
  return missing;
}

export function feMissingLabels(missing: FeMissingField[]): string[] {
  const map: Record<FeMissingField, string> = {
    nombre: 'Nombre',
    documento: 'Cédula / documento',
    email: 'Email',
  };
  return missing.map((m) => map[m]);
}
